import { render, staticRenderFns } from "./Tuto.vue?vue&type=template&id=852150f0&scoped=true&"
import script from "./Tuto.vue?vue&type=script&lang=js&"
export * from "./Tuto.vue?vue&type=script&lang=js&"
import style0 from "./Tuto.vue?vue&type=style&index=0&id=852150f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852150f0",
  null
  
)

export default component.exports